// CSV のエンコーディング正規化（純関数・DuckDB 非依存）。
//
// 役割: DuckDB の read_csv_auto は UTF-8 前提で Shift-JIS を解せないため、取込前にバイト列を
//       UTF-8 へ正規化する。UTF-8 として妥当ならそのまま、妥当でなければ Shift-JIS とみなして
//       UTF-8 へ変換する（日本の市区町村 CSV 等に多い Shift-JIS 対応）。
// 関係: loadFile.js の CSV 取込（レイヤー / データ両方）が registerFileBuffer の直前に通す。
//       node --test で検証できるよう、ブラウザ非依存の標準 API（TextDecoder/TextEncoder）のみ使う。

// CSV バイト列（Uint8Array）を UTF-8 のバイト列に正規化して返す。
// UTF-8 として妥当なら入力をそのまま返す（BOM 等を保つ）。妥当でなければ Shift-JIS として
// デコードし直し、UTF-8 へ再エンコードした新しいバイト列を返す。
export function csvBufferToUtf8(bytes) {
  try {
    // fatal:true なので不正なバイト列（Shift-JIS など）は例外になる。
    new TextDecoder('utf-8', { fatal: true }).decode(bytes)
    return bytes
  } catch {
    const text = new TextDecoder('shift_jis').decode(bytes)
    return new TextEncoder().encode(text)
  }
}
